import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';

import Link from '../Link';

import { SlideOut, SlideOutBtn, SlideOutBody } from './styles';

// * Data {obj} the content obj that is pulled form CMS
// * onMount (func) to be called when the slide mounts
// * SlideIsOpen {bool} to check if the slide is open
// * onSlideClick (func) to be called when the slide button is clicked

const Slide = ({
  data,
  onMount,
  slideIsOpen,
  slideLabel,
  onSlideClick,
  resetState,
}) => {
  const ref = useRef(null);
  const {
    text: secondaryText,
    // link: secondaryLink,
    url,
    queryString,
    ariaLabel,
    subitems: secondaryItems,
  } = data;

  // * On mount, get the height of the slide and pass it into the onMount func
  useEffect(() => {
    if (ref.current && slideIsOpen) {
      onMount(ref.current.clientHeight);
    }
  }, [slideIsOpen]);

  // * When the slide is clicked, call the onSlideClick func and pass in the label
  const handleClick = () => {
    onSlideClick(slideLabel);
  };

  return (
    <li>
      {url ? (
        <Link
          to={`${url}/`}
          queryString={queryString}
          ariaLabel={ariaLabel}
          onClick={() => resetState()}
        >
          {secondaryText}
        </Link>
      ) : (
        <SlideOut className={['slideout', slideIsOpen ? 'is-open' : '']}>
          <SlideOutBtn type="button" onClick={handleClick}>
            {secondaryText}
          </SlideOutBtn>
          <SlideOutBody ref={ref}>
            <ul className="no-bullets">
              {secondaryItems &&
                secondaryItems.map(
                  (
                    {
                      text: tertiaryText,
                      url: tertiaryLink,
                      linkType,
                      queryString: qString,
                      ariaLabel: aLabel,
                    },
                    index
                  ) => {
                    const isPDF = linkType === '.pdf';
                    const isQuery = qString !== 'undefined';
                    return (
                      <li
                        key={`slideout-links-${tertiaryText}-${index.toString()}`}
                      >
                        {tertiaryLink ? (
                          <Link
                            to={
                              isPDF || isQuery
                                ? tertiaryLink
                                : `${tertiaryLink}/`
                            }
                            className={isPDF && 'is-pdf'}
                            queryString={qString}
                            ariaLabel={aLabel}
                            onClick={() => resetState()}
                          >
                            {tertiaryText}
                          </Link>
                        ) : (
                          <p
                            key={`slideout-links-${tertiaryText}-${index.toString()}`}
                          >
                            {tertiaryText}
                          </p>
                        )}
                      </li>
                    );
                  }
                )}
            </ul>
          </SlideOutBody>
        </SlideOut>
      )}
    </li>
  );
};

Slide.propTypes = {
  data: PropTypes.shape().isRequired,
  onMount: PropTypes.func,
  slideLabel: PropTypes.string,
  slideIsOpen: PropTypes.bool,
  onSlideClick: PropTypes.func,
  resetState: PropTypes.func,
};

Slide.defaultProps = {
  onMount: () => {},
  slideLabel: null,
  slideIsOpen: false,
  onSlideClick: () => {},
  resetState: null,
};

export default Slide;
